import React, { useState, useRef } from "react";
import {
  Container,
  LeftIcon,
  SearchContainer,
  TitleWithName,
  MasterContainer,
} from "./Navigator.styled";
import { Icon, Typography } from "@ann/web-components";
import { useNavigate, useLocation } from "react-router-dom";
import { getContactsList } from "../../../../../services/contacts";
import { useContactHeader } from "../../hooks/useContactHeader";

const Navigator = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { contactDetails } = useContactHeader();
  const contactName = contactDetails?.name || location.state?.contactName;
  const [contacts, setContacts] = useState([]);
  const [selectedContact, setSelectedContact] = useState([]);
  const [loading, setLoading] = useState(false);
  const searchTimeoutRef = useRef(null);


  const loadContacts = async (searchTerm = null) => {
    setLoading(true);
    try {
      const response = await getContactsList({
        page: 1,
        page_size: 15,
        search: searchTerm ? searchTerm  : null,
      });
      setContacts(response.body || []);
    } catch (error) {
      console.error("Error loading contacts:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    navigate("/v2/ucp");
  };

  const handleSelectionChange = (selected) => {
    const normalizedSelection = Array.isArray(selected)
      ? selected
      : selected
      ? [selected]
      : [];

    setSelectedContact(normalizedSelection);

    const contact = normalizedSelection[0];

    if (!contact?.partyUuid) {
      return;
    }

    const currentPath = location.pathname;
    const pathMatch = currentPath.match(/\/v2\/ucp\/[^/]+\/(.+)/);
    const contactName = contact.legalName || contact.firstName || contact.lastName || null;

    if (pathMatch) {
      const currentSection = pathMatch[1];
      navigate(`/v2/ucp/${contact.partyUuid}/${currentSection}`, { 
        state: { contactName } 
      });
    } else {
      navigate(`/v2/ucp/${contact.partyUuid}/overview`, { 
        state: { contactName } 
      });
    }
  };

  const handleSearch = (searchTerm) => {
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }
    
    searchTimeoutRef.current = setTimeout(() => {
      loadContacts(searchTerm);
    }, 500);
  };

  return (
    <MasterContainer>
      <Container>
        <LeftIcon>
          <Icon name="arrowLeft" onClick={handleBack} size="custom" width="16px" height="16px"/>
        </LeftIcon>
        <SearchContainer>
          <TitleWithName>
            <Typography category="title" size="small" weight="bold">Contact details</Typography>
            {contactName && (
              <Typography category="body" size="small" color="body">{contactName}</Typography>
            )}
          </TitleWithName>
        </SearchContainer>
      </Container>
    </MasterContainer>
  );
};

export default Navigator;
